<template>
  <section class="ai-faq" aria-labelledby="ai-faq-title">
    <button class="ai-faq__back" type="button" @click="$emit('close')"><span aria-hidden="true">←</span> Back</button>
    <h3 id="ai-faq-title" ref="heading" tabindex="-1">How Knowledge AI works</h3>
    <dl>
      <div>
        <dt>What can I ask?</dt>
        <dd>Ask a question and add the details the assistant needs. Follow-up questions in the same chat use that conversation's context. Start a new chat for a separate topic.</dd>
      </div>
      <div>
        <dt>Does it see the lead I have open?</dt>
        <dd>No. This is your personal chat. Lead details and customer conversations are not included automatically. Add any relevant context yourself. Replies stay here and are not sent to customers.</dd>
      </div>
      <div>
        <dt>What do the message statuses mean?</dt>
        <dd><strong>Queued</strong> means your message is waiting. <strong>AI is working</strong> means a reply is being prepared. <strong>Retry scheduled</strong> means another attempt will happen automatically. If a request fails, use <strong>Retry request</strong> when available, or <strong>Need help</strong>.</dd>
      </div>
      <div>
        <dt>How do I manage chats?</dt>
        <dd>Open <strong>Chats</strong> to switch conversations or create a new one. Use the ••• menu to rename or pin a chat. Green pins mark chats kept at the top. The sort icon changes the order; <strong>Load more chats</strong> shows more conversations.</dd>
      </div>
      <div>
        <dt>Is my conversation saved?</dt>
        <dd>Sent messages and replies are saved. You can minimize the panel or switch chats while waiting. Unsent drafts stay while this page is open, but a page reload clears them.</dd>
      </div>
      <div>
        <dt>How do I send a message or report a problem?</dt>
        <dd>Press <strong>Enter</strong> to send and <strong>Shift + Enter</strong> for a new line. <strong>Need help</strong> opens a support ticket form on this page and includes the page context. Describe the problem and click <strong>Create ticket</strong>. Knowledge AI is in beta; check answers before using them with customers.</dd>
      </div>
    </dl>
  </section>
</template>

<script>
export default {
  name: 'KnowledgeChatFaq',
  mounted() { this.$refs.heading.focus() }
}
</script>

<style lang="scss" scoped>
.ai-faq { flex: 1; min-height: 0; overflow-y: auto; padding: 16px; background: $ui-surface-soft; }
.ai-faq__back { display: inline-flex; align-items: center; gap: 6px; padding: 6px 0; border: 0; background: transparent; color: $ui-blue; cursor: pointer; font-size: 12px; font-weight: 600; }
.ai-faq h3 { margin: 12px 0 16px; color: $ui-ink; font-size: 16px; font-weight: 600; }
.ai-faq h3:focus { outline: none; }
.ai-faq__back:focus-visible { outline: 2px solid $ui-blue; outline-offset: 3px; }
.ai-faq dl { display: grid; gap: 16px; margin: 0; }
.ai-faq dt { margin-bottom: 5px; color: $ui-ink; font-size: 13px; font-weight: 600; }
.ai-faq dd { margin: 0; color: $ui-muted; font-size: 12px; line-height: 1.65; }
</style>
